module.exports = __webpack_public_path__ + "img/Group 849.28c386f0.png";